/*

  i n d e x
  Index

  :description:
  Our main entrypoint, imports/exports all of our classes.

*/

//
//  :classes:
import AndroidARLaunch from "./android/AndroidARLaunch";
import iOSARLaunch from "./ios/iOSARLaunch";
import QRARLaunch from "./qrs/QRARLaunch";

//
//  :window-exports:
/* istanbul ignore next */
if (window) {
  window.AndroidARLaunch = AndroidARLaunch
  window.iOSARLaunch = iOSARLaunch
  window.QRARLaunch = QRARLaunch
}

//
//  :es6-exports:
export { AndroidARLaunch, iOSARLaunch, QRARLaunch }
